import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';

import _ from 'lodash';

import withRefetchConsumer from '~/modules/core/utils/relayHelpers/withRefetchConsumer';
import objectsDeepNotEqualComparison from '~/modules/core/utils/jsHelpers/objectsDeepComparison';
import { mediaQueryMax } from '~/modules/core/utils/cssHelpers/cssMedia';
import FilteringAccordion from './itemsListFilter/FilteringAccordion';
import FiltersUpdater from './FiltersUpdaterWrapper';
import FilterAccordionFactory from './FilterAccordionFactory';
import ModalFilteringAccordion from './ModalFilteringAccordion';

export const ITEMS_LIST_VIEW_FILTER_KEY = 'items_list_view_filter';

class ItemsListFilter extends Component {
  static getDerivedStateFromProps(nextProps, currentState) {
    const nextFiltersProp = nextProps.refetchData && nextProps.refetchData.filters;

    const newPropsReceived = objectsDeepNotEqualComparison(
      currentState.previousFiltersProps,
      nextFiltersProp,
    );

    if (newPropsReceived) {
      return {
        // Workaround to keep the previously received props shown
        allFilters: nextFiltersProp ? _.cloneDeep(nextFiltersProp) : currentState.allFilters,
        previousFiltersProps: _.cloneDeep(nextFiltersProp),
      };
    }
    return null;
  }

  state = {
    allFilters: [],
    previousFiltersProps: [], // eslint-disable-line react/no-unused-state
  };

  filterUpdater = new FiltersUpdater(this.props.refetchMethod);

  constructor(props) {
    super(props);
    this.filtersBuilder = new FilterAccordionFactory(
      this.onFilterCheckboxClicked,
      this.onPriceApplyClicked,
      this.onFilterRatingClicked,
    );
  }

  // eslint-disable-next-line react/sort-comp
  onFilterCheckboxClicked = (filterCategoryName, clickedOption) => {
    let allFilters = _.clone(this.state.allFilters);

    allFilters = allFilters.map(
      filter => (filter.name === filterCategoryName
        ? {
          ...filter,
          options: filter.options.map(
            option => (option.name === clickedOption.name ? this.toggledOption(option) : option),
          ),
        }
        : filter),
    );

    this.updateState(allFilters);
  };

  onFilterRatingClicked = (clickedOption) => {
    let allFilters = _.clone(this.state.allFilters);

    allFilters = allFilters.map(
      filter => (filter.name === 'ratings'
        ? {
          ...filter,
          options: filter.options.map(
            option => (option.selected || option.name === clickedOption.name
              ? this.toggledOption(option)
              : option),
          ),
        }
        : filter),
    );

    this.updateState(allFilters);
  };

  onPriceApplyClicked = (updatedPrices) => {
    let allFilters = _.clone(this.state.allFilters);
    allFilters = allFilters.map(
      filter => (filter.name === 'price'
        ? {
          ...filter,
          options: this.applyPriceChanges(updatedPrices),
        }
        : filter),
    );
    this.updateState(allFilters);
  };

  applyPriceChanges = filter => filter.map(
    item => (item.name === 'min_price' || item.name === 'max_price' ? this.selectOption(item) : item),
  );

  updateState = (allFilters) => {
    this.setState(
      {
        allFilters,
      },
      () => this.refetchFilters(),
    );
  };

  toggledOption = option => ({
    ...option,
    selected: !option.selected,
  });

  selectOption = option => ({
    ...option,
    selected: true,
  });

  refetchFilters = () => {
    this.filterUpdater.refetch(this.state.allFilters);
  };

  render() {
    return (
      <Media query={mediaQueryMax('tablet')}>
        {matches => (matches ? (
          <ModalFilteringAccordion
            panels={this.filtersBuilder.buildFilterGroups(this.state.allFilters)}
            isLoading={this.props.isLoading}
            showFilterDropdown={this.props.showFilterDropdown}
          />
        ) : (
          <FilteringAccordion
            panels={this.filtersBuilder.buildFilterGroups(this.state.allFilters)}
            isLoading={this.props.isLoading}
            showFilterDropdown={this.props.showFilterDropdown}
          />
        ))
        }
      </Media>
    );
  }
}

ItemsListFilter.propTypes = {
  refetchMethod: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  showFilterDropdown: PropTypes.bool,
};
ItemsListFilter.defaultProps = {
  showFilterDropdown: false,
};
export default withRefetchConsumer(ItemsListFilter);
